<template src="./index.html"></template>

<script>
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
const columns = [
  {
    title: "№",
    width: "5%",
    scopedSlots: { customRender: "number" },
    align: "center",
  },
  {
    title: "Şikayət mətni",
    width: "15%",
    scopedSlots: { customRender: "comptext" },
    align: "center",
  },
  {
    title: "Yerli icra hakimiyyəti orqanı",
    dataIndex: "executive.name",
    width: "15%",
    align: "center",
  },
  {
    title: "Ünvan",
    scopedSlots: { customRender: "address" },
    width: "13%",
    align: "center",
  },
  {
    title: "İdarələr",
    scopedSlots: { customRender: "offices" },
    width: "13%",
    align: "center",
  },
  {
    title: "",
    scopedSlots: { customRender: "actions" },
    width: "5%",
    align: "center",
  },
];
export default {
  name: "ComplaintsList",
  props: ["dataSource", "type"],
  components: {
    "conditional-media": ConditionalMedia,
  },
  data() {
    return {
      details: [],
      columns,
      mylocale: { emptyText: "Məlumat yoxdur" },
      pagination: { pageSize: 5, current: 1 },
      mediadialogVisibility: false,
      files: [],
    };
  },
  methods: {
    deleteDetail(index) {
      this.details = this.details.filter((val) => {
        return val.no != index;
      });
      this.$emit("change", this.details);
    },
    editDetail(index) {
      this.$emit("edit", this.details[index]);
      this.details = this.details.filter((val) => {
        return val.no != index;
      });
      this.$emit("change", this.details);
    },
    showMedia(record) {
      this.files = record.files;
      this.mediadialogVisibility = true;
    },
  },
  created() {
    this.details = this.dataSource;
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
